// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__kyJhG","left":"InfoRow_left__26hzX"};